<!--begin::Contact person modal component-->
<template>
    <div id="reset-password-contact-modal" class="modal fade show reset-password-contact-modal" tabindex="-1" role="dialog" aria-labelledby="resetPasswordContactModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document" style="max-width: 900px !important;">
            <div class="modal-content">
                <!-- Starts::Reset Password Section -->
                 <Form @submit="changePassword" :validation-schema="schema" class="kt-form kt-form--label-right">
                    <div class="modal-header">
                        <h5 class="modal-title" id="resetPasswordContactModalLabel">{{ $t('reset_password_contact_person') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <div class="col-lg-6">
                                <label class="">{{ $t('new_password') }}*:</label>
                                <Field :type="showPass ? 'text' : 'password'" name="password" v-model="password"  @keyup="checkPasswordStrength()" class="form-control form-control-solid  h-auto py-4 px-4 rounded"  />
                                <span @click="showPassword">
                                    <i class="icon-toggle toggle-password icon-lg fa" :class="{ 'fa-eye': showPass, 'fa-eye-slash': !showPass }"></i>
                                </span>
                                <ErrorMessage  name="password" class="error-message"/>
                                <div class="d-flex align-items-center mb-3 mt-1">
                                    <div id="StrengthDisp1" class="flex-grow-1 bg-active-success rounded h-5px mr-1" style="background-color:#E4E6EF"></div>
                                    <div id="StrengthDisp2" class="flex-grow-1 bg-active-success rounded h-5px mr-1" style="background-color:#E4E6EF"></div>
                                    <div id="StrengthDisp3" class="flex-grow-1 bg-active-success rounded h-5px" style="background-color:#E4E6EF"></div>
                                </div>
                                <div class="text-muted">
                                    {{ $t('check_password_strength') }}
                                </div>                                     
                            </div>
                            <div class="col-lg-6">
                                <label>{{ $t('confirm_new_password') }}*:</label>
                                <Field :type="showConfirmPass ? 'text' : 'password'" name="password_confirmation" v-model="password_confirmation" class="form-control form-control-solid  h-auto py-4 px-4 rounded"  />
                                <span @click="showConfirmPassword">
                                    <i class="icon-toggle toggle-password icon-lg fa" :class="{ 'fa-eye': showConfirmPass, 'fa-eye-slash': !showConfirmPass }"></i>
                                </span>
                                <ErrorMessage name="password_confirmation" class="error-message"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('close') }}</button>
                        <button type="submit" :class="{'btn btn-primary':true , 'spinner spinner-white spinner-right' : this.spinner}" :disabled="isActiveApproveButton">{{ $t('update') }}</button>
                    </div>
                </Form>
                <!-- Ends::Reset Password Section -->
            </div>
        </div>
    </div>
</template>
<!--end::Contact person modal component-->

<script>
import ContactPersonAPIService from '@/js/api/customers/contact-persons';
import { Field, Form, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
    export default {
        name: 'ContactPersonModalComponent',
        components: {
            Form,
            Field,
            ErrorMessage,
        },
        props: [
            "customerId",
            "userToken",
        ],
        data() {
            return {
                contact_person_id: '',
                password: '',
                password_confirmation: '',
                isActiveApproveButton: false,
                spinner:false,
                showPass:'',
                showConfirmPass:'',
                schema: yup.object({
                password: yup.string()
                    .required('Password is required')
                    .test('password-complexity', 'Password must be at least 8 characters long and include at least one uppercase letter', (value) => {
                    const regex = /^(?=.*[A-Z]).{8,}$/;
                    return regex.test(value);
                    }),
                password_confirmation: yup.string()
                    .required('Confirm password is required')
                    .oneOf([yup.ref('password')], 'Confirm Password do not match'),
                })
            };
        },
        computed: {

        },
        mounted: function() {
            this.$root.eventBus.on('resetPasswordContactSharedData', (contactPerson) => {
                this.contact_person_id = contactPerson.id;
            }) 
        },
        methods: {
            changePassword: function() {
                this.isActiveApproveButton = true;
                this.spinner=true;
                var data = {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                }
                ContactPersonAPIService.changePassword(this.$route.params.id, this.contact_person_id, data, this.access_token).then((response) => {
                    if(response.data.hasOwnProperty("success")){
                        // time to close popup.
                        $('#reset-password-contact-modal').modal('hide');
                        this.password = null;
                        this.password_confirmation = null;
                        swal.fire({
                            title: "Success!",
                            text: response.data.success,
                            icon: "success",
                            confirmButtonText: "OK"
                        }).then((result) => {
                            if (result.value){
                                // TODO: Close modal here
                            }
                        });
                        this.isActiveApproveButton = false;
                        this.spinner=false;
                    }
                    else if(response.data.hasOwnProperty("error")){
                        this.spinner=false;
                        this.isActiveApproveButton = false;
                        var errorsHtml = '';
                        $.each(response.data.error, function(index, error) {
                            errorsHtml += '<span class="kt-font-danger">' + error + '</span><br>';
                        });
                    }
                }).catch((error) => {
                    this.isActiveApproveButton = false;
                    this.spinner=false;
                    swal.fire("Error Exception!","Error", "error");
                    console.log("error: "+ error.response);
                });
            },
            showPassword(){
                this.showPass = !this.showPass;
            },
            showConfirmPassword(){
                this.showConfirmPass = !this.showConfirmPass;
            },
        }
    };
</script>
<style scoped>
.displayBadge{
    margin-top: 5%; 
    display: none;
}
.icon-toggle {
   float: right;
   margin-left: -25px;
   margin-top: -29px;
   position: relative;
   z-index: 2;
   color: gray;
   margin-right: 11px;
}
.form-control.is-invalid{
    background-image: none !important;
}
</style>